import * as mqtt from "precompiled-mqtt";
import { IClusterInfoResponse, IMachineCenterInfoResponse } from "./LocalserverSetupMethodsInterfaces";

export const handleConnect = (
    client: mqtt.MqttClient,
    responseTopic: string,
    requestTopic: string,
    reject: (reason?: any) => void,
    requestPacket: { clusterId: number; timestamp: number } | { machineCenterId: number; timestamp: number },
) => {
    client.subscribe(responseTopic, (err) => {
        if (err) {
            client.end();
            reject(new Error(`Failed to subscribe to ${responseTopic}`));
            return;
        }

        client.publish(requestTopic, JSON.stringify(requestPacket), {
            qos: 1,
        });
    });
};

export const handleClusterMessage = (
    topic: string,
    message: Buffer,
    client: mqtt.MqttClient,
    responseTopic: string,
    timestamp: number,
    reject: (reason?: any) => void,
    resolve: (value: IClusterInfoResponse | PromiseLike<IClusterInfoResponse>) => void,
    timeoutId: NodeJS.Timeout,
) => {
    if (topic === responseTopic) {
        try {
            const response = JSON.parse(message.toString()) as IClusterInfoResponse;
            if (
                response.timestamp &&
                response.clusterInfo &&
                (response.timestamp === timestamp || response.timestamp > timestamp)
            ) {
                clearTimeout(timeoutId);
                resolve(response);
                client.end();
            } else if (response.error) {
                clearTimeout(timeoutId);
                client.end();
                reject(response.error);
            }
        } catch (error) {
            clearTimeout(timeoutId);
            client.end();
            reject(new Error("Failed to parse response"));
        }
    }
};

export const handleMachineCenterMessage = (
    topic: string,
    message: Buffer,
    client: mqtt.MqttClient,
    responseTopic: string,
    timestamp: number,
    reject: (reason?: any) => void,
    resolve: (value: IMachineCenterInfoResponse | PromiseLike<IMachineCenterInfoResponse>) => void,
    timeoutId: NodeJS.Timeout,
) => {
    if (topic === responseTopic) {
        try {
            const response = JSON.parse(message.toString()) as IMachineCenterInfoResponse;
            if (
                response.timestamp &&
                response.machineCenterInfo &&
                (response.timestamp === timestamp || response.timestamp > timestamp)
            ) {
                clearTimeout(timeoutId);
                resolve(response);
                client.end();
            } else if (response.error) {
                clearTimeout(timeoutId);
                client.end();
                reject(response.error);
            }
        } catch (error) {
            clearTimeout(timeoutId);
            client.end();
            reject(new Error("Failed to parse response"));
        }
    }
};
